import React from 'react';
import { useSelector } from 'react-redux';

import { RecordSVG } from 'assets/img';
import { ImageView, TextView } from 'components';
import useChannelDetails from 'hooks/useChannelDetails';
import { selectSelectedContent } from 'redux/content/content.slice';

import { MessageWrapper, MobileImage } from './RightPanel';

export const MobilePreview = () => {
  const selectedContent = useSelector(selectSelectedContent);
  const channelDetails = useChannelDetails();
  const isChannelIvrOrConversationBot =
    channelDetails.channel === 'ivr' ||
    channelDetails.channel === 'conversationBot';
  return (
    <div className="flex h-[568px] w-[290px]">
      <MobileImage
        imageUrl={channelDetails.imageUrl}
        className={`flex justify-start ${
          channelDetails.channel === 'whatsapp' ? 'items-end' : 'items-start'
        } pt-[70px] pb-[94px]  px-6`}
      >
        <div className="flex flex-col gap-10 w-full">
          <div className="w-full flex justify-center items-center">
            <TextView
              align="left"
              textType="body"
              color="#000"
              size={10}
              fontStyle="normal"
              weight="100"
              lineHeight={20}
              text={selectedContent.senderId || ''}
            />
          </div>
          {!isChannelIvrOrConversationBot && (
            <div
              className="flex w-full max-h-[345px] pb-4"
              style={{
                position: 'relative',
                overflowY: 'auto',
                // minHeight: 'fit-content',
              }}
            >
              <MessageWrapper
                className="flex w-[200px] "
                style={{
                  backgroundColor: '#E9E9EB',
                  // overflowY: 'auto',
                  scrollbarWidth: 'thin', // For Firefox
                  scrollbarColor: '#8D8D8F #E9E9EB',
                  padding: '5px 10px',
                  minHeight: 25,
                  wordBreak: 'break-all',
                  height: 'fit-content',
                  borderTopLeftRadius: 9,
                  borderTopRightRadius: 9,
                  borderEndEndRadius: 9,
                }}
              >
                <TextView
                  textType="body"
                  color="#475467"
                  size={10}
                  fontStyle="normal"
                  weight="100"
                  lineHeight={20}
                  text={selectedContent.message?.trim()}
                />
              </MessageWrapper>
            </div>
          )}
          {isChannelIvrOrConversationBot && (
            <div className="flex flex-col justify-center items-center gap-3 h-2/3 w-full">
              <ImageView src={RecordSVG} />
              <TextView
                textType="body"
                color="#475467"
                size={16}
                fontStyle="normal"
                weight="100"
                lineHeight={20}
                text={'Preview coming soon'}
              />
            </div>
          )}
        </div>
      </MobileImage>
    </div>
  );
};
